$(document).ready(function() {

    /* file (photos) upload in review -- start */
    const fileUploader = function () {

        var maxFileSize = 10 * 1024 * 1024; // (байт) Максимальный размер файла (10мб)
        var queue = {}; //очередь
        const image_inputWrap = $('.imageUploader__inputWrap');
        const image_input = $('input#loadImg');
        const image_infoText = $('.imageUploader .imageUploader__text');
        const errorBox = $('.imageUploader').find('.errorBox');
        let errorText = $('.imageUploader').find('.errorBox .error__text');

        var imagesList = $('#display_imageContainer');

        var itemPreviewTemplate = imagesList.find('.imageWrap.template').clone();
        itemPreviewTemplate.removeClass('template');
        imagesList.find('.template').remove();


        image_input.on('change', function () {
            var files = this.files;

            if (imagesList.children().length + files.length > 5) {
                errorBox.addClass('active');
                errorText.html('Можно добавить до 5 фотографий.');
                return;
            } else {
                errorBox.removeClass('active');
            }

            for (var i = 0; i < files.length; i++) {
                var file = files[i];

                if ( !file.type.match(/image\/(jpeg|jpg|png|bmp|gif)/) ) {
                    errorBox.addClass('active');
                    errorText.html('Поддерживаются только расширения файлов: jpg, jpeg, png, bmp, gif');

                    return;
                } else {
                    errorBox.removeClass('active');
                }

                if ( file.size > maxFileSize ) {
                    errorBox.addClass('active');
                    errorText.html('Размер файла не должен превышать 10 MБ.');

                    return;
                } else {
                    errorBox.removeClass('active');
                }

                preview(files[i]);
            }

            if (files.length > 0) {
                image_infoText.addClass('hide');
            }

            if (imagesList.children().length + files.length === 5) {
                image_inputWrap.addClass('hide');
            }

            this.value = '';
        });

        // Создание превью
        function preview(file) {
            var reader = new FileReader();

            reader.addEventListener('load', function(event) {

                var itemPreview = itemPreviewTemplate.clone();

                itemPreview.css("background-image", "url(" + reader.result + ")");
                itemPreview.data('id', file.name);

                imagesList.append(itemPreview);

                queue[file.name] = file;
            });

            reader.readAsDataURL(file);
        }

        // Удаление фотографий
        imagesList.on('click', '.delete-link', function () {
            errorBox.removeClass('active');

            console.log(this);

            var item = $(this).closest('.imageWrap'),
                id = item.data('id');

            delete queue[id];

            item.remove();

            if (imagesList.children().length < 1) {
                image_infoText.removeClass('hide');
            }

            if (imagesList.children().length < 5) {
                image_inputWrap.removeClass('hide');
            }
        });


        // Отправка формы /*заготовка*/
        /*form.on('submit', function(event) {
            var formData = new FormData(this);
            for (var id in queue) {
                formData.append('images[]', queue[id]);
            }
            $.ajax({
                url: $(this).attr('action'),
                type: 'POST',
                data: formData,
                async: true,
                success: function (res) {
                    alert(res)
                },
                cache: false,
                contentType: false,
                processData: false
            });
            return false;
        });*/

    };
    fileUploader();
    /* file (photos) upload in review -- end */
});
